import { useState } from "react";
import { Wand2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

const plural = (n, one, many) => (n === 1 ? one : many);

export const BulkGenerate = ({ terms, onStarted }) => {
  const [kinds, setKinds] = useState({ comic: true, map: true });
  const [busy, setBusy] = useState(false);
  const missing = (k) => terms.filter((t) => [undefined, null, "none", "error"].includes(t[`${k}_status`])).length;
  const counts = { comic: missing("comic"), map: missing("map") };
  const selected = Object.keys(kinds).filter((k) => kinds[k] && counts[k] > 0);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/teacher/bulk-generate", { kinds: selected });
      toast.success(`Avviati: ${data.comic ?? 0} fumetti, ${data.map ?? 0} mappe`);
      onStarted();
    } catch (e) {
      toast.error(errorText(e));
    } finally {
      setBusy(false);
    }
  };

  const check = (k, label) => (
    <label className="flex items-center gap-2 text-sm font-bold">
      <input type="checkbox" checked={kinds[k]} onChange={(e) => setKinds({ ...kinds, [k]: e.target.checked })} data-testid={`bulk-${k}-checkbox`} className="h-4 w-4" />
      {label} mancanti <span className="rounded-full bg-[var(--paper)] px-2" data-testid={`bulk-${k}-count`}>{counts[k]}</span>
    </label>
  );

  return (
    <div className="ink-box-sm mt-8 flex flex-wrap items-center gap-4 rounded-2xl bg-white p-4" data-testid="bulk-generate-panel">
      <span className="font-display text-lg font-bold">Generazione in blocco</span>
      {check("comic", "Fumetti")}
      {check("map", "Mappe")}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button disabled={!selected.length || busy} data-testid="bulk-generate-button" className="ink-box-sm ink-press ml-auto flex items-center gap-2 rounded-full bg-[var(--coral)] px-5 py-2 font-extrabold text-white disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />} Genera tutto
          </button>
        </AlertDialogTrigger>
        <AlertDialogContent className="rounded-3xl border-[2.5px] border-[var(--ink)]" data-testid="bulk-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Avviare la generazione in blocco?</AlertDialogTitle>
            <AlertDialogDescription>
              Verranno creati {kinds.comic ? counts.comic : 0} {plural(kinds.comic ? counts.comic : 0, "fumetto", "fumetti")} e {kinds.map ? counts.map : 0} {plural(kinds.map ? counts.map : 0, "mappa concettuale", "mappe concettuali")}. Usa crediti AI e può richiedere qualche minuto.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="bulk-cancel-button">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={run} data-testid="bulk-confirm-button" className="bg-[var(--coral)]">Avvia</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
